import React from 'react';
import LocalDate from '../../LocalDate/LocalDate';
import { Container } from '@plone/components';

const RequestDateView = (props) => {
  const { content, data, properties } = props;
  const expander =
    content?.['@components']?.['request-date'] ||
    properties?.['@components']?.['request-date'] ||
    {};
  const request_date = expander?.['date'] || null;
  const texto = data?.text || 'Dados atualizados em: ';
  return (
    request_date && (
      <Container className={`block request-date`}>
        <Container narrow>
          <p className="date">
            {texto}{' '}
            <LocalDate date={request_date} includeTime={data?.long || false} />
          </p>
        </Container>
      </Container>
    )
  );
};

export default RequestDateView;
